import $ from 'jquery';
import {toggleCloudCurrency} from '../helpers';
const {__, _x, _n, _nx} = wp.i18n;

class Vdc {
    constructor() {
        this.orderForm = $('.gf-vdc');

        if (!this.orderForm.length) return;

        this.orderField = $('.gf-vdc__order input');

        this.props = document.querySelector('.gf-vdc__list')
        this.submitBtn = this.orderForm.find('input[type=submit]');

        this.events();
    }

    events() {
        $(document).on('gform_post_render', this.switchPriceAndCurrency.bind(this));
        gform.addAction('gform_input_change', this.createOrder.bind(this));
        gform.addAction('gform_input_change', this.minPropsLogic.bind(this));
        gform.addFilter('gform_product_total', this.formatTotalPrice.bind(this));
    }

    minPropsLogic() {
        const ssdVolume = +this.orderForm.find('.gf-vdc__qty--ssd:visible input').val();
        const hddVolume = +this.orderForm.find('.gf-vdc__qty--hdd:visible input').val();

        const cpuVolume = +this.orderForm.find('.gf-vdc__qty--vcpu:visible input').val();
        const cpuAdvancedVolume = +this.orderForm.find('.gf-vdc__qty--vcpu-adv:visible input').val();

        const storageNotice = this.orderForm.find('.gf-vdc__storage-notice');
        const cpuNotice = this.orderForm.find('.gf-vdc__cpu-notice');

        const isMinStorage = ssdVolume + hddVolume < 200;
        const isMinCpu = cpuVolume + cpuAdvancedVolume < 8;

        this.showNotice(isMinStorage, storageNotice)
        this.showNotice(isMinCpu, cpuNotice)

        if(isMinStorage || isMinCpu) {
            this.submitBtn.attr('disabled', 'disabled');
        } else {
            this.submitBtn.removeAttr('disabled');
        }
    }

    showNotice(isMinProp, noticeEl)
    {
        if(isMinProp) {
            noticeEl.fadeIn();
        } else {
            noticeEl.fadeOut();
        }
    }

    getVdcItems() {
        const region = $('.gf-vdc__region').find('option:selected').val();
        const vdcProp = $(`.gf-vdc__prop--${region}`);

        // Облако для бэкапа
        const cloudBackup = $('.gf-vdc__cloud:visible option:selected').val()
            ? JSON.parse($('.gf-vdc__cloud:visible option:selected').val())
            : {volume: "", price: "0", currency: "RUB", unit: ""};

        let currency, regionid;
        if (region === 'ru') {
            currency = 'RUB';
            regionid = 1;
        } else {
            currency = 'EUR';
            regionid = 2;
        }

        let order = [];
        let items = {};
        let totalPrice = 0;

        vdcProp.each(function () {
            let label = $(this).find('label').text().toLowerCase().replace(' storage', '').replace('floating ', '');
            if (label === 'ips') {
                label = 'ip';
            }
            if (label === 'vcpu') {
                label = 'cpu';
            }
            let price = +$(this).find('.ginput_product_price').next('input').val();
            let qty = +$(this).next('.gf-vdc__qty').find('input').val();

            items[label] = {
                count: qty,
                price: price
            }

            if (qty) {
                totalPrice = totalPrice + (price * qty);
            }

        });

        order.push({
            regionid,
            name: '',
            items,
            period: 1,
            currency,
            totalPrice
        });

        if (cloudBackup.volume) {
            order[0]['storage'] = {
                volume: cloudBackup.volume,
                unit: cloudBackup.unit,
                price: cloudBackup.price,
                currency: cloudBackup.currency
            }
        }

        /**
         * Set Google Analytics value
         */
        const $gaTotalPriceField = $('.gf-vdc__ga-total-price input');

        /**
         * ATLEX_OBJ.exchange_rate.eur
         */
        let gaTotalPrice;
        if (currency !== 'RUB') {
            gaTotalPrice = parseFloat(totalPrice) * parseFloat(ATLEX_OBJ.exchange_rate.eur) + parseFloat(cloudBackup.price);
        } else {
            gaTotalPrice = parseFloat(totalPrice) + parseFloat(cloudBackup.price);
        }

        $gaTotalPriceField.val(gaTotalPrice)

        this.orderField.val(JSON.stringify(order));
    }

    // Auto-populate count of properties
    qtyPopulate() {
        const vdcCounts = {};
        const props = ['vcpu', 'ram', 'ssd', 'hdd', 'ip'];

        for (let prop of props) {
            // get value
            vdcCounts[prop] = $('.gf-vdc__qty--' + prop).find('input:visible').val();
            // set value
            $('.gf-vdc__qty--' + prop).find('input:not(:visible)').val(vdcCounts[prop])
        }

    }

    switchPriceAndCurrency(price, priceField, currencyField) {

        const isEuRegion = $('.gf-vdc__region option:selected').val() === 'eu';
        const isCurrencyRub = $('.gf-vdc__currency input').is(':checked');

        if(priceField.closest('.gfield').hasClass('gf-vdc__total-price')) {
            if (!isEuRegion) {
                priceField.text(price.toLocaleString('ru-RU'));
                currencyField.text(__('руб.', 'atlex'));
            } else if (isEuRegion && !isCurrencyRub) {
                priceField.text(price.toLocaleString('en-GB'));
                currencyField.text(__('евро', 'atlex'));
            } else if (isEuRegion && isCurrencyRub) {
                price = Math.round(price * ATLEX_OBJ.exchange_rate.eur);
                priceField.text(price.toLocaleString('ru-RU'));
                currencyField.text(__('руб.', 'atlex'));
            }
        } else {
            if (!isEuRegion) {
                $(priceField).next('.gf-vdc__switched-price').remove()
                $(priceField).after(`<span class="gf-vdc__switched-price">${price.toLocaleString('ru-RU')}</span>`);
                currencyField.text(__('руб.', 'atlex'));
            } else if (isEuRegion && !isCurrencyRub) {
                $(priceField).next('.gf-vdc__switched-price').remove()
                $(priceField).after(`<span class="gf-vdc__switched-price">${price.toLocaleString('en-GB')}</span>`);
                currencyField.text(__('евро', 'atlex'));
            } else if (isEuRegion && isCurrencyRub) {
                price = Math.round(price * ATLEX_OBJ.exchange_rate.eur);
                $(priceField).next('.gf-vdc__switched-price').remove()
                $(priceField).after(`<span class="gf-vdc__switched-price">${price.toLocaleString('ru-RU')}</span>`);
                currencyField.text(__('руб.', 'atlex'));
            }
        }
    }

    formatTotalPrice(total, formId) {
        setTimeout(() => {
            const currencyField = $('.gf-vdc__total-price .gfield_description');
            const totalPriceField = $('.gf-vdc__total-price .ginput_total');

            if (total) {
                this.switchPriceAndCurrency(total, totalPriceField, currencyField);
            }

        }, 1)
    }

    calcPriceRUB() {

        const pricesField = this.orderForm.find('.gf-vdc__prop');
        const region = $('.gf-vdc__region').find('option:checked').val()

        pricesField.each((idx, item) => {
            let price = +$(item).find('.ginput_product_price').val()
            const inputPrice = $(item).find('.ginput_product_price');
            const currencyField = $(item).find('.gfield_description')
            this.switchPriceAndCurrency(price, inputPrice, currencyField)

        });

        if (region !== 'ru') {
            toggleCloudCurrency('vdc');
        }

    }

    calcTotalPriceRUB() {

        const totalPriceFiled = $('.gf-vdc__total-price');
        const totalPriceInput = totalPriceFiled.find('input');
        const totalPriceText = totalPriceFiled.find('.gfield_description');

        const isCurrencyRub = $('.gf-vdc__currency input').is(':checked');
        const currency = isCurrencyRub ? this.currencyRubTranslated : this.currencyEuroTranslated;

        let price = +totalPriceInput.val().replace(' ', '');

        if (isCurrencyRub) {
            price = Math.round(price * ATLEX_OBJ.exchange_rate.eur).toLocaleString('ru-RU');
        } else {
            price = price.toLocaleString('en-GB');
        }

        totalPriceText.text(price + ' ' + currency);

    }

    createOrder(elem, formId, fieldId) {
        this.calcPriceRUB();
        this.formatTotalPrice();
        this.getVdcItems();

        setTimeout(() => {
            this.qtyPopulate(elem);
        }, 1)
    }

}

export default Vdc;
